module.exports = __webpack_public_path__ + "img/6-4.6e38c499.png";